import { Navigate, Outlet } from 'react-router-dom';
import type { Permission } from '@/config/permissions';
import { usePermissions } from '@/shared/hooks/usePermissions';
import { useAuth } from '@/providers/AuthProvider';

type RequirePermissionProps = {
  permission: Permission;
};

/** Block route when user lacks required permission. */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const { can } = usePermissions();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!can(permission)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Outlet />;
}
